import React, {createContext, Dispatch, ReactNode, SetStateAction, useContext, useEffect, useState} from 'react';
import {IAddPaymentContext} from 'types/payment';
import {useMmsService} from "services/mms/context/MmsServiceContext.tsx";

interface AllPaymentContextProps {
    payments: IAddPaymentContext[] | null;
    setPayments: Dispatch<SetStateAction<IAddPaymentContext[] | null>>;
    removePayment: (index: number) => void;
}

export const AllPaymentContext = createContext<AllPaymentContextProps | null>(null);

export const AllPaymentProvider: React.FC<{ children: ReactNode }> = ({ children }) => {

    const mmsService = useMmsService()
    const paymentService = mmsService.getPaymentService()
    const { data: dataPayment, sendRequest: fetchPayment } = paymentService.useGetSelfPayment()
    const [payments, setPayments] = useState<IAddPaymentContext[] | null>(null);

    useEffect(() => {
        fetchPayment()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if(dataPayment){
            const typedData = dataPayment as IAddPaymentContext[]
            setPayments(typedData)
        }
    }, [dataPayment]);

    const removePayment = (index: number) => {
        if (payments) {
            const updatedPayments = [...payments];
            updatedPayments.splice(index, 1);
            setPayments(updatedPayments);
        }
    };

    const contextValue: AllPaymentContextProps = {
        payments,
        setPayments,
        removePayment
    };

    return <AllPaymentContext.Provider value={contextValue}>{children}</AllPaymentContext.Provider>;
};

export const UseAllPaymentContext = () => {
    const context = useContext(AllPaymentContext);
    if (!context) {
        throw new Error('useAllPaymentContext must be used within an AllPaymentProvider');
    }
    return context;
};
